import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

var foreGroundColor = "#014891";

const Spinner = () => (
  <span style={{ color: foreGroundColor }}>
    <FontAwesomeIcon className="fas fa-solid fa-spin" icon={faSpinner} />
  </span>
);

export { Spinner };
